import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import PublicAssortiment from "../components/assortiment/PublicAssortiment";

export default function AssortimentView() {
  return (
    <div className="pageWrapper">
      <Header title="Publiek Assortiment" showSearch={true} />
      <div className="contentWrapper fadeInDelayed">
        <PublicAssortiment />
      </div>
      <BottomNavBar />
    </div>
  );
}
